import React, {
  useEffect,
} from 'react';
import {
  useImpersonation,
} from 'core/context/impersonation';
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import {
  notEmptyString,
} from '@populateui/utils';
import {
  formatTime,
} from 'utils/date';
import Button from 'pages/Dashboard/components/Button';
import {
  useAuth,
} from 'core/hooks';
import Tooltip from 'core/components/Tooltip';
import {
  APP_ROUTES,
} from 'views/EMR/router';

export default function ImpersonationBanner() {
  const {
    impersonation,
    isImpersonating,
    stopImpersonation,
  } = useImpersonation();

  const { logout } = useAuth();

  useEffect(() => {
    if (isImpersonating && impersonation) {
      document.body.classList.add('user-impersonation-active');
    }
  }, [impersonation, isImpersonating]);

  return (isImpersonating && impersonation) ? (
    <div className="bg-amber-500 border-y border-amber-600 text-slate-900 px-3 py-1 flex items-center justify-center gap-2 z-[9999] sticky top-0 text-sm">
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-0.5">
          <GppMaybeIcon className="!text-slate-900 !w-6 !h-6" />
          <span className="font-semibold">Impersonating:</span>
        </div>
        <span className="font-semibold">{impersonation.userName}</span>
        {notEmptyString(impersonation?.userEmail) && (
          <span className="border border-slate-700 px-2 py-0.5 rounded-full font-medium text-xs">{impersonation?.userEmail}</span>
        )}
        •
        <span className="font-medium text-xs">
          until
          {' '}
          <span className="font-semibold">{formatTime(impersonation?.expiresOnTimestamp ?? '')}</span>
        </span>
      </div>
      <div className="flex items-center gap-3 !ml-10">
        <Tooltip title="Stop impersonation & go back to portal dashboard">
          <Button
            variant="contained"
            color="primary"
            onClick={stopImpersonation}
            className="!bg-slate-900 !text-white !border !border-slate-900 hover:!bg-slate-800 rounded-lg text-xs !px-3 !py-1.5 !h-7"
          >
            Stop
          </Button>
        </Tooltip>
        <Tooltip title="Stop impersonation & logout from portal">
          <Button
            variant="outlined"
            onClick={async () => {
              await logout({ returnTo: `${window.location.origin}${APP_ROUTES.POPULATE_SUPPORT.ROOT}` });
            }}
            className="!text-slate-900 !border-slate-900 hover:!text-slate-800 rounded-lg text-xs !px-3 !py-1.5 !h-7"
          >
            Logout
          </Button>
        </Tooltip>
      </div>
    </div>
  ) : null;
}
